export enum AnimationConfigType {
  SMALL = 'SMALL_SCREEN_ITEM_ANIMATION_CONFIG',
  MEDIUM = 'MEDIUM_SCREEN_ITEM_ANIMATION_CONFIG',
  TABLET = 'TABLET_SCREEN_ITEM_ANIMATION_CONFIG',
  DESKTOP = 'DESKTOP_SCREEN_ITEM_ANIMATION_CONFIG',
}

export type Scale = {
  start: number;
  end: number;
};

export type Rotation = {
  min: number;
  max: number;
};

export type Position = {
  x: number;
  y: number;
};

export type TitleAnimationScreenConfig = {
  scale: Scale;
  frequency: {
    left: number;
    right: number;
  };
  rotation: {
    left: Rotation;
    right: Rotation;
  };
};

export type TitleAnimationConfig = {
  scale: Scale;
  frequency: number;
  rotation: Rotation;
  position: Position;
};

const DESKTOP_SCREEN_ITEM_ANIMATION_CONFIG: TitleAnimationScreenConfig = {
  scale: {
    start: 0.2,
    end: 0.6,
  },
  frequency: {
    left: 1.4,
    right: 1.8,
  },
  rotation: {
    left: {
      min: 210,
      max: 270,
    },
    right: {
      min: 270,
      max: 330,
    },
  },
};

const TABLET_SCREEN_ITEM_ANIMATION_CONFIG: TitleAnimationScreenConfig = {
  scale: {
    start: 0.2,
    end: 0.5,
  },
  frequency: {
    left: 1.4,
    right: 1.7,
  },
  rotation: {
    left: {
      min: 230,
      max: 280,
    },
    right: {
      min: 280,
      max: 330,
    },
  },
};

const MEDIUM_SCREEN_ITEM_ANIMATION_CONFIG: TitleAnimationScreenConfig = {
  frequency: {
    left: 1.2,
    right: 1.1,
  },
  rotation: {
    left: {
      min: -100,
      max: -60,
    },
    right: {
      min: -120,
      max: -80,
    },
  },
  scale: {
    start: 0.2,
    end: 0.35,
  },
};

const SMALL_SCREEN_ITEM_ANIMATION_CONFIG: TitleAnimationScreenConfig = {
  frequency: {
    left: 1.2,
    right: 1.1,
  },
  rotation: {
    left: {
      min: -100,
      max: -60,
    },
    right: {
      min: -120,
      max: -80,
    },
  },
  scale: {
    start: 0.15,
    end: 0.25,
  },
};

export const titleAnimationScreenConfigs = {
  [AnimationConfigType.SMALL]: SMALL_SCREEN_ITEM_ANIMATION_CONFIG,
  [AnimationConfigType.MEDIUM]: MEDIUM_SCREEN_ITEM_ANIMATION_CONFIG,
  [AnimationConfigType.TABLET]: TABLET_SCREEN_ITEM_ANIMATION_CONFIG,
  [AnimationConfigType.DESKTOP]: DESKTOP_SCREEN_ITEM_ANIMATION_CONFIG,
};
